import CustomPreloader from '@components/CustomPreloader'

import './suspenseFallback.scss'

const SuspenseFallback = () => (
  <div className='suspense-fallback-wrapper'>
    <CustomPreloader />
  </div>
)

export default SuspenseFallback
